import { useState, useEffect, useRef } from "react";

interface UseStickyScrollOptions {
    offset?: number;
}

export const useStickyScroll = (options: UseStickyScrollOptions = {}) => {
    const { offset = 0 } = options;
    const [isSticky, setIsSticky] = useState(false);
    const elementRef = useRef<HTMLDivElement>(null);
    const elementTopRef = useRef<number>(0);

    useEffect(() => {
        const handleScroll = () => {
            if (elementRef.current) {
                const rect = elementRef.current.getBoundingClientRect();

                if (elementTopRef.current === 0 && rect.top > 0) {
                    elementTopRef.current = rect.top + window.scrollY;
                }

                const scrolledPast = window.scrollY > elementTopRef.current - offset;

                setIsSticky(scrolledPast);
            }
        };

        const handleResize = () => {
            elementTopRef.current = 0;
            handleScroll();
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("resize", handleResize, { passive: true });

        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, [offset]);

    return {
        elementRef,
        isSticky,
    };
};
